import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { resetTransportOrderFilter, setTransportOrdersSort, updateTransportOrderFilter } from '../actions';
import { selectTransportOrderFilter, selectTransportOrderSeparateListFilter } from '../selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import ButtonComponent from '../../../containers/App/Components/Button/Button';

const FiltersWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: start;
  align-items: center;
  // padding: 12px 0;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterLabel = styled.div`
  background-color: var(--color-new-primary);
  color: var(--color-new-white);

  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 5px;
`;

const DeleteFilterButton = styled.div`
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ClearButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #df4074;
  text-decoration: underline;
  cursor: pointer;
`;

const altFilters = ['sell_without_license_plate', 'dont_fix_damages'];

/* eslint-disable react/prefer-stateless-function */
class FiltersCloudComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  deleteFilter = filterName => {
    this.props.reset(filterName);
  };

  clearAllFilters = () => {
    this.props.clearAll();
  };

  render() {
    const filtersList = this.props.filter?.properties?.filter(f => !altFilters?.includes(f.key));

    const filterName = name => this.lblStr(`transport_order.filter.${name}`);
    const filterValue = (value, type, label, name) => {
      if (name === 'regplate' || name === 'task_label') {
        return label[0];
      }

      if (value.id) {
        return value?.company_type !== 'individual' ? value?.name ?? '' : `${value?.name ?? ''} ${value?.surname ?? ''}`;
      }

      switch (type) {
        case 'multiple':
          return label?.length ? label.join(', ') : value.join(', ');

          case 'ranged_date': {
            const isValid = str => typeof str === 'string' && str.trim() !== '' && str !== 'from' && str !== 'tot';
          
            const from = isValid(label[0]) ? label[0] : isValid(value[0]) ? value[0] : '';
            const to = isValid(label[1]) ? label[1] : isValid(value[1]) ? value[1] : '';
          
            let descr = '';
            if (from) descr += `${this.lblStr('transport_order.filter.from')} ${from} `;
            if (to) descr += `${this.lblStr('transport_order.filter.to')} ${to}`;
          
            return descr.trim();
          }

            
        default:
          return label && label[0]
            ? label[0]
            : value[0] == '1'
            ? `${filterName('yes')}`
            : value[0] == '0'
            ? `${filterName('no')}`
            : value[0];
      }
    };
    const sortTypeLabel = this.lblStr(`transport_order.sort.${this.props.filter?.sortType}`);
    const { weblogin, filter } = this.props;
    return (
      <FiltersWrapper>
        {filter?.sortType && (
          <FilterLabel key={'transport_order_sort'}>
            {`${this.lblStr('transport_order.sort.by')}: ${sortTypeLabel}, ${filter?.order}`}
            {!weblogin && (
              <DeleteFilterButton onClick={this.props.resetSort}>
                <FontAwesomeIcon icon={faTimes} />
              </DeleteFilterButton>
            )}
          </FilterLabel>
        )}
        {filtersList?.map(filter => {
          return (
            <FilterLabel key={filter?.key}>
              {`${filterName(filter?.key)}: ${filterValue(filter?.value, filter?.type, filter?.label, filter?.key)}`}
              <DeleteFilterButton onClick={() => this.deleteFilter(filter?.key)}>
                <FontAwesomeIcon icon={faTimes} />
              </DeleteFilterButton>
            </FilterLabel>
          );
        })}
        {!weblogin && filtersList?.length > 0 && (
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.clearAllFilters}>
            <FontAwesomeIcon icon={faTimes} />
          </ButtonComponent>
        )}
      </FiltersWrapper>
    );
  }
}

FiltersCloudComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: ownProps.separateFilter ? selectTransportOrderSeparateListFilter() : selectTransportOrderFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(filterName) {
      dispatch(
        updateTransportOrderFilter(null, {
          reset: filterName,
          separateFilter: ownProps.separateFilter,
        }),
      );
    },
    resetSort() {
      dispatch(setTransportOrdersSort(null, null));
    },
    clearAll: () => {
      dispatch(resetTransportOrderFilter({ separateFilter: ownProps.separateFilter ?? null }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FiltersCloud = compose(withConnect, withRouter, injectIntl)(FiltersCloudComp);
